module.exports = "<template> <div ref=calendar></div> </template>";